module.exports = __webpack_public_path__ + "img/yinhe-active.dd0989f5.jpg";